import { render } from "./DashboardEditGiftCard.vue?vue&type=template&id=8e2a0774&scoped=true"
import script from "./DashboardEditGiftCard.vue?vue&type=script&lang=js"
export * from "./DashboardEditGiftCard.vue?vue&type=script&lang=js"

import "./DashboardEditGiftCard.vue?vue&type=style&index=0&id=8e2a0774&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e2a0774"]])

export default __exports__